import React, {useContext} from "react"
import Themes from 'themes';
import './index.css'
const ThemeContext = React.createContext(Themes.themes1);


const Titlebar = props => {
  const {classNames, title} = props;
  const Themes = useContext(ThemeContext);
  return(
    <div className="titleBar hidden">
       <p className={classNames} style={{color: Themes.title}}>{title}</p>
    </div>
  )
}

export default Titlebar
